/** 数値の優先度を持つ最小ヒープ（経路探索用。値は整数 ID） */
export class MinHeap {
  private ids: Int32Array;
  private keys: Float64Array;
  private n = 0;

  constructor(capacity = 1024) {
    this.ids = new Int32Array(capacity);
    this.keys = new Float64Array(capacity);
  }

  get size(): number {
    return this.n;
  }

  clear(): void {
    this.n = 0;
  }

  push(id: number, key: number): void {
    if (this.n === this.ids.length) this.grow();
    let i = this.n++;
    while (i > 0) {
      const p = (i - 1) >> 1;
      const pk = this.keys[p] as number;
      if (pk <= key) break;
      this.ids[i] = this.ids[p] as number;
      this.keys[i] = pk;
      i = p;
    }
    this.ids[i] = id;
    this.keys[i] = key;
  }

  /** 最小の要素の ID を取り出す。空なら -1 */
  pop(): number {
    if (this.n === 0) return -1;
    const top = this.ids[0] as number;
    const lastId = this.ids[--this.n] as number;
    const lastKey = this.keys[this.n] as number;
    let i = 0;
    for (;;) {
      const l = 2 * i + 1;
      if (l >= this.n) break;
      const r = l + 1;
      const c = r < this.n && (this.keys[r] as number) < (this.keys[l] as number) ? r : l;
      if ((this.keys[c] as number) >= lastKey) break;
      this.ids[i] = this.ids[c] as number;
      this.keys[i] = this.keys[c] as number;
      i = c;
    }
    this.ids[i] = lastId;
    this.keys[i] = lastKey;
    return top;
  }

  private grow(): void {
    const ids = new Int32Array(this.ids.length * 2);
    const keys = new Float64Array(this.keys.length * 2);
    ids.set(this.ids);
    keys.set(this.keys);
    this.ids = ids;
    this.keys = keys;
  }
}
